import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoDistributionPage } from '@/features/promotion/pages/PromoDistributionPage';
import { promoAssignmentSearchSchema } from '@/features/promotion/types/promotion.types';

export const Route = createFileRoute('/_auth/promotion/distribution')({
  beforeLoad: () => requirePermission(PROMOTION_PERMISSIONS.DISTRIBUTION_VIEW),
  validateSearch: promoAssignmentSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Promotional Item Distribution">
      <Suspense fallback={<PageLoader />}>
        <PromoDistributionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
